import React from 'react';

/* El nombre de un cliente, con su logo adelante.

   Se usa en todo el super admin para poder reconocer al cliente de un vistazo,
   sin leer. Es chiquito a propósito: acompaña al nombre, no compite con él.

   Cuando el cliente no tiene logo cargado queda un círculo tenue con su
   inicial: se ve el hueco, pero no llama la atención ni desalinea la fila.

   Ojo, no usa BrandAvatar: aquel detecta con canvas si el logo tiene fondo
   transparente, y hacer esa lectura por cada fila de una tabla de cien
   clientes cuesta caro (y llena la consola de avisos de Canvas2D). Acá, a 22
   píxeles, alcanza con centrar la imagen sobre blanco. */

export function AvatarCliente({ src, nombre, size = 22 }) {
  const [falló, setFalló] = React.useState(false);
  const inicial = (nombre || '?').trim().charAt(0).toUpperCase();
  const hay = src && !falló;
  return (
    <span aria-hidden="true" style={{
      width: size, height: size, borderRadius: '50%', flex: '0 0 auto',
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      overflow: 'hidden', background: hay ? '#fff' : 'var(--bg-hover)',
      border: '1px solid var(--border)',
    }}>
      {hay ? (
        <img src={src} alt="" onError={() => setFalló(true)}
          style={{ width: '82%', height: '82%', objectFit: 'contain' }} />
      ) : (
        <span style={{ fontSize: size * 0.46, fontWeight: 700, color: 'var(--text-muted)', opacity: 0.65 }}>{inicial}</span>
      )}
    </span>
  );
}

export default function NombreCliente({ nombre, logo, size = 22, style, className, children }) {
  return (
    <span className={className} style={{ display: 'inline-flex', alignItems: 'center', gap: 8, minWidth: 0, ...style }}>
      <AvatarCliente src={logo} nombre={nombre} size={size} />
      <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {children ?? nombre}
      </span>
    </span>
  );
}
